import React from "react"
import { Box, Container, Grid, Heading } from "@theme-ui/components"

const Embed = ({ title, code, fullWidth = false }) => {
  return (
    <Box sx={{ position: "relative", backgroundColor: "light", pb: [6] }}>
      {fullWidth && (
        <Container>
          <Box
            sx={{
              position: "relative",
              paddingBottom: "56.25%",
              iframe: {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                borderRadius: "0 35px",
              },
            }}
            dangerouslySetInnerHTML={{ __html: code }}
          />
        </Container>
      )}
      {!fullWidth && (
        <Box
          sx={{
            zIndex: 1,
          }}
        >
          <Grid
            columns={[1, 1, 1, "1fr 1fr"]}
            gap={[0, 0, 32]}
            sx={{
              py: [0, 0, 7],
              position: "relative",
              height: "100%",
              alignItems: "center",
            }}
          >
            <Container>
              {title && (
                <Heading
                  color="dark"
                  as="h2"
                  variant="h3"
                  sx={{
                    mt: [0, 0],
                    fontWeight: "300",
                    textAlign: ["left", "left", "left", "right"],
                  }}
                >
                  {title}
                </Heading>
              )}
            </Container>
            <Container>
              <Box
                sx={{
                  // height: "100%",
                  position: "relative",
                  paddingBottom: "56.25%",
                  iframe: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    borderRadius: "0 35px",
                  },
                }}
                dangerouslySetInnerHTML={{ __html: code }}
              />
            </Container>
          </Grid>
        </Box>
      )}
    </Box>
  )
}

export default Embed
